import { Image as DatoImage } from 'react-datocms';
import clsx from 'clsx';
import CtaButton from 'components/CtaButton';
import InlineRichText from 'components/RichContent/InlineRichText';
import { ResponsiveImage } from 'services/graphql';

import styles from './AdModule.module.css';

const variantClassName = {
  '2_col': styles.twoCol,
  '3_col': styles.threeCol,
};

interface AdModuleRecord {
  /**
   * Markdown
   */
  text1: string;
  /**
   * Markdown
   */
  text2: string;

  /**
   * Markdown
   */
  cta: string;
  image: ResponsiveImage;
  id: string;
  anchor?: string;
  __typename: string;

  variant: '2_col' | '3_col';
}

export default function AdModule({ variant = '2_col', text1, text2, cta, image, anchor }: AdModuleRecord) {
  const { width, height } = image?.responsiveImage || {};
  const aspectRatio = width / (height ?? width);

  return (
    <div
      data-testid={`ad-module-${variant}`}
      id={anchor}
      className={clsx(styles.module, variantClassName[variant])}
    >
      <div className={styles.wrapper}>
        <div className={styles.contentGrid}>
          {variant === '2_col' ? (
            <div className={styles.textColumn}>
              <InlineRichText
                as="h2"
                className={styles.text1TwoCol}
              >
                {text1}
              </InlineRichText>
              <CtaButton className={styles.cta}>{cta}</CtaButton>
            </div>
          ) : (
            <>
              <InlineRichText
                as="h2"
                className={styles.text1ThreeCol}
              >
                {text1}
              </InlineRichText>
              <div className={styles.middleColumn}>
                <InlineRichText
                  as="p"
                  className={styles.text2}
                >
                  {text2}
                </InlineRichText>
                <CtaButton className={styles.cta}>{cta}</CtaButton>
              </div>
            </>
          )}
          {image && (
            <div
              className={styles.imageColumn}
              style={{ aspectRatio }}
            >
              <DatoImage
                data={image?.responsiveImage}
                layout="fill"
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
